import { PropertyInactiveScreenContainer } from "src/containers";

export const PropertyInactiveScreen = () => {
  return <PropertyInactiveScreenContainer />;
};
